// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-item.trip-item.sub {\n    text-indent: 3em;\n}", ""]);
// Exports
module.exports = exports;
